import { eplStyles } from "../clientstyles/commonstyles";
import { applyAcceptToEditor, cleanupItem } from './SuggestionAction';
import "./AutoSuggestion.css"
import { epl } from "../clientstyles/epl";
import { edp } from "../clientstyles/edp";

// const styleRegistry = {
//     epl: epl,
//     edp: edp,
//     common: eplStyles,
// };

// ─────────────────────────────────────────────────────────
// MODULE-LEVEL STATE
// ─────────────────────────────────────────────────────────
let globalAnchorList = [];   // in-memory live anchor list
let globalRejectedAnchorList = [];
let globalPropsRef = null; // always-fresh Redux props reference
let activeStyles = [];
let globalRejectedRef = null;  // ← add this
export let globalRejectedIds = new Set();
let globalRejectedPositions = [];
let globalRejectedKeys = new Set();

// ─────────────────────────────────────────────────────────
// UTILITIES — used inside every style's execute()
// ─────────────────────────────────────────────────────────

// Convert flat text index → { startRow, startCol, endRow, endCol }
export function getPositionFromIndex(text, startIndex, length) {
    let row = 0, col = 0;
    for (let i = 0; i < startIndex; i++) {
        if (text[i] === '\n') { row++; col = 0; } else col++;
    }
    const startRow = row, startCol = col;
    for (let i = startIndex; i < startIndex + length; i++) {
        if (text[i] === '\n') { row++; col = 0; } else col++;
    }
    return { startRow, startCol, endRow: row, endCol: col };
}

// Create one anchor entry and push to anchorlist
export function createAnchor(
    session, Range, position,
    originalText, suggestionText,
    markerClass, styleName, description,
    anchorlist, extraStyleInfo = {}
) {
    const id = `${styleName}__${crypto.randomUUID()}`;

    const startAnchor = session.doc.createAnchor(position.startRow, position.startCol);
    const endAnchor = session.doc.createAnchor(position.endRow, position.endCol);
    startAnchor.$insertRight = false;
    endAnchor.$insertRight = true;

    const range = new Range(position.startRow, position.startCol, position.endRow, position.endCol);
    const markerId = session.addMarker(range, markerClass, "background");

    anchorlist.push({
        id,
        startAnchor,
        endAnchor,
        markerId,
        originalText,
        suggestionText,
        range,
        styleInfo: { name: styleName, description, ...extraStyleInfo }
    });
}

export function cleanupAnchor(session, item) {
    console.log("cleanupAnchor called for:", item.originalText, "markerId:", item.markerId);
    if (item.markerId) session.removeMarker(item.markerId);
    if (item.startAnchor?.detach) item.startAnchor.detach();
    if (item.endAnchor?.detach) item.endAnchor.detach();
}

// Remove one item from globalAnchorList
export function removeFromGlobalAnchorList(item) {
    const i = globalAnchorList.indexOf(item);
    if (i > -1) globalAnchorList.splice(i, 1);
}

// ─────────────────────────────────────────────────────────
// DUPLICATE / STALE DETECTION HELPERS
// Called inside each style's execute() before createAnchor
// ─────────────────────────────────────────────────────────

// Check if this position already has a live anchor for this style
export function isAlreadyAnchored(position, styleName, existingSuggestions) {
    return existingSuggestions.some(ex =>
        ex.styleInfo.name === styleName &&
        ex.startAnchor.row === position.startRow &&
        ex.startAnchor.column === position.startCol &&
        ex.endAnchor.column === position.endCol &&
        ex.endAnchor.row === position.endRow
    );
}

// Check if this match overlaps any existing anchor — returns overlapping items
export function getOverlappingAnchors(position, styleName, existingSuggestions) {
    return existingSuggestions.filter(ex =>
        ex.styleInfo.name === styleName &&
        ex.startAnchor.row === position.startRow &&
        (
            ex.startAnchor.column === position.startCol ||
            (ex.startAnchor.column >= position.startCol && ex.startAnchor.column < position.endCol) ||
            (ex.endAnchor.column > position.startCol && ex.endAnchor.column <= position.endCol)
        )
    );
}

// export function isAlreadyAnchored(position, styleName, existingSuggestions, originalText = null) {
//     return existingSuggestions.some(ex =>
//         ex.styleInfo.name === styleName &&
//         ex.startAnchor.row === position.startRow &&
//         ex.startAnchor.column === position.startCol &&
//         ex.endAnchor.column === position.endCol &&
//         // ── If originalText provided, also verify content matches ──
//         (originalText === null || ex.originalText === originalText)
//     );
// }


// export function getOverlappingAnchors(position, styleName, existingSuggestions, originalText = null) {
//     return existingSuggestions.filter(ex =>
//         ex.styleInfo.name === styleName &&
//         ex.startAnchor.row === position.startRow &&
//         (
//             ex.startAnchor.column === position.startCol ||
//             (ex.startAnchor.column >= position.startCol && ex.startAnchor.column < position.endCol) ||
//             (ex.endAnchor.column > position.startCol && ex.endAnchor.column <= position.endCol)
//         )
//     );
// }
// export function isRejectedPosition(position, styleName, originalText) {
//     return globalRejectedPositions.some(r =>
//         r.styleName === styleName &&
//         r.originalText === originalText &&
//         r.row === position.startRow &&
//         r.col === position.startCol
//     );
// }
export function isRejectedByLivePosition(position, styleName, originalText) {
    return globalRejectedAnchorList.some(item =>
        item.styleInfo?.name === styleName &&
        item.originalText === originalText &&
        item.startAnchor.row === position.startRow &&  // ← live row, auto-updated by Ace
        item.startAnchor.column === position.startCol     // ← live col, auto-updated by Ace
    );
}

// Check if this match was previously rejected
// export function isRejected(originalText, styleName, rejectedSuggestions, lineContent = null, col = null) {
//     return rejectedSuggestions.some(r => {
//         if (r.originalText !== originalText || r.styleName !== styleName) return false;
//         if (r.lineContent && lineContent && r.col !== undefined && col !== null) {
//             return r.lineContent === lineContent && r.col === col;
//         }
//         if (r.lineContent && lineContent) return r.lineContent === lineContent;
//         return true;
//     });
// }

// Remove the old isRejected function entirely
// Replace with this:
// export function isRejectedById(position, styleName, existingSuggestions, rejectedIds) {
//     // Find if there's an existing anchor at this exact position
//     // whose id is in the rejected set
//     const existingAtPos = existingSuggestions.find(ex =>
//         ex.styleInfo.name === styleName &&
//         ex.startAnchor.row === position.startRow &&
//         ex.startAnchor.column === position.startCol
//     );
//     return existingAtPos ? rejectedIds.has(existingAtPos.id) : false;
// }

// ─────────────────────────────────────────────────────────
// DELETED ANCHOR DETECTION
// Run after styles execute — finds anchors whose text
// no longer exists at the live position
// ─────────────────────────────────────────────────────────
function findDeletedAnchors(texFile, existingSuggestions) {
    const deletedIds = new Set();
    const lines = texFile.split('\n');

    existingSuggestions.forEach(item => {
        const row = item.startAnchor.row;
        const col = item.startAnchor.column;
        const line = lines[row];

        if (line === undefined) {
            deletedIds.add(item.id);
            return;
        }
        const textAtPosition = line.substring(col, col + item.originalText.length);
        if (textAtPosition !== item.originalText) {
            deletedIds.add(item.id);
        }
    });

    return deletedIds;
}

// ─────────────────────────────────────────────────────────
// ACCEPT / REJECT ACTIONS
// Used by both popup and EditCorrections
// ─────────────────────────────────────────────────────────
export function acceptItem(editor, item, setTextFile, props, setAllFiles = null) {
    try {
        // ── Always use live object from globalAnchorList ──
        const liveItem = globalAnchorList.find(a => a.id === item.id) || item;

        applyAcceptToEditor(editor, liveItem, setTextFile, setAllFiles);
        cleanupAnchor(editor.session, liveItem);
        removeFromGlobalAnchorList(liveItem);
        props?.removeAutoSuggestion(liveItem);
    } catch (err) {
        console.error("Accept error:", err);
    }
}

export function rejectItem(editor, item, props) {
    try {
        const liveItem = globalAnchorList.find(a => a.id === item.id) || item;

        // ── Remove marker and detach END anchor only ──
        // Keep startAnchor ALIVE so it keeps tracking row/col changes
        if (liveItem.markerId) editor.session.removeMarker(liveItem.markerId);
        if (liveItem.endAnchor?.detach) liveItem.endAnchor.detach();

        // ── Mark as rejected but keep in a separate tracking list ──
        liveItem.markerId = null;        // no marker anymore
        liveItem.rejected = true;        // flag it as rejected

        // Move from globalAnchorList to globalRejectedAnchorList
        removeFromGlobalAnchorList(liveItem);
        globalRejectedAnchorList.push(liveItem);  // ← startAnchor still live tracking

        const rejectedEntry = {
            id: liveItem.id,
            originalText: liveItem.originalText,
            styleName: liveItem.styleInfo?.name,
            anchorRef: liveItem.startAnchor   // ← live Ace anchor reference
        };

        globalRejectedKeys.add(liveItem.id);

        if (globalRejectedRef) {
            globalRejectedRef = [...globalRejectedRef, rejectedEntry];
        } else {
            globalRejectedRef = [rejectedEntry];
        }

        props?.addAutoSuggestionReject({
            id: liveItem.id,
            originalText: liveItem.originalText,
            styleName: liveItem.styleInfo?.name
        });
        props?.removeAutoSuggestion(liveItem);
    } catch (err) {
        console.error("Reject error:", err);
    }
}

// ─────────────────────────────────────────────────────────
// MAIN FUNCTION — call on every keystroke
// ─────────────────────────────────────────────────────────
export async function AutoSuggestion(
    texFile, ace, selectedStyles = [], client,
    props, setTextFile, fileName, Allfiles
) {
    if (!props.showSuggestion) {
        globalPropsRef = null;
        return;
    }
    const styleRegistry = {
        epl: epl,
        edp: edp,
        common: { ...eplStyles, ...epl, ...edp },
    };

    globalPropsRef = props.autoSuggestions;
    props.startLoading();
    globalRejectedRef = props.autoSuggestionsRejected || [];  // ← add this
    console.log("the client and the client datas are", client, "epd", edp, "epl", epl)
    if (props.view === "suggestions") {
        if (!ace?.current) { props.StopLoading(); return null; }
        const styleSource = styleRegistry[client] || styleRegistry.common;
        activeStyles = selectedStyles
            .map(name => styleSource[name])
            .filter(Boolean);

        if (activeStyles.length === 0) {
            props.StopLoading();
            return [];
        }

        try {
            const editor = ace.current.editor;
            const session = editor.session;
            const Range = window.ace.require('ace/range').Range;

            await new Promise(r => setTimeout(r, 100));

            removePopup();

            // ── Fresh data from Redux every run ──
            const existingSuggestions = props.autoSuggestions || [];
            const rejectedSuggestions = props.autoSuggestionsRejected || [];
            const newAnchorList = [];
            const allStaleIds = new Set();

            // ── Run each style ──
            for (const style of activeStyles) {
                if (typeof style.execute !== 'function') continue;
                try {
                    const result = style.execute(
                        texFile, session, Range, newAnchorList,
                        fileName, Allfiles,
                        existingSuggestions,
                        rejectedSuggestions
                    );
                    const returned = (result instanceof Promise) ? await result : result;
                    if (returned instanceof Set) {
                        returned.forEach(id => allStaleIds.add(id));
                    }
                } catch (err) {
                    console.error(`Style "${style.name}" error:`, err);
                }
            }

            // ── Find deleted anchors ──
            const deletedIds = findDeletedAnchors(texFile, existingSuggestions);
            deletedIds.forEach(id => allStaleIds.add(id));
            // ── Clean up rejected anchors whose text was deleted ──
            cleanupStaleRejectedAnchors(texFile);  // ← ADD THIS

            // ── Cleanup stale/deleted anchors ──
            if (allStaleIds.size > 0) {
                existingSuggestions
                    .filter(item => allStaleIds.has(item.id))
                    .forEach(item => cleanupAnchor(session, item));
                props.removeStaleAutoSuggestions([...allStaleIds]);
            }



            // ── Auto apply — sequential mode 
            if (!props.showIsChecked && props.autoapply) {
                let temp = texFile;

                for (const style of activeStyles) {
                    if (typeof style.execute !== 'function') continue;

                    try {
                        // ── Collect matches using a dummy anchorlist ──
                        // We create a temporary fake session-like object that
                        // records positions without touching the real Ace session
                        const matchList = [];

                        // ── Fake session for autoapply — records positions only ──
                        const fakeDoc = {
                            createAnchor: (row, col) => ({
                                row,
                                column: col,
                                $insertRight: false,
                                detach: () => { }
                            })
                        };
                        const fakeSession = {
                            doc: fakeDoc,
                            addMarker: () => null,        // no real marker
                            removeMarker: () => { },
                            getLine: (row) => temp.split('\n')[row] || ''
                        };
                        const FakeRange = function (sr, sc, er, ec) {
                            return { start: { row: sr, column: sc }, end: { row: er, column: ec } };
                        };

                        const result = style.execute(
                            temp,
                            fakeSession,
                            FakeRange,
                            matchList,
                            fileName,
                            Allfiles,
                            [],   // no existing suggestions
                            []    // no rejected
                        );
                        if (result instanceof Promise) await result;

                        if (matchList.length === 0) continue;

                        // ── Special handling for preamble ──
                        const preambleItem = matchList.find(i => i.styleInfo?.isPreambleInsertion);
                        if (preambleItem) {
                            const titleMatch = /\\title\s*\{/i.exec(temp);
                            if (titleMatch) {
                                temp = preambleItem.suggestionText + temp.slice(titleMatch.index);
                            }
                            continue; // preamble handled, move to next style
                        }

                        // ── Special handling for fullLine removal ──
                        // Handle these separately — sort by row descending so line numbers don't shift
                        const fullLineItems = matchList.filter(i => i.styleInfo?.removeType === 'fullLine');
                        const otherItems = matchList.filter(i => i.styleInfo?.removeType !== 'fullLine');

                        // Process fullLine removals top-down by row descending
                        if (fullLineItems.length > 0) {
                            const lines = temp.split('\n');
                            const rowsToRemove = new Set(
                                fullLineItems.map(i => i.startAnchor.row)
                            );
                            temp = lines
                                .filter((_, idx) => !rowsToRemove.has(idx))
                                .join('\n');
                        }

                        // ── Standard position-based replacement — bottom to top ──
                        const sorted = [...otherItems].sort((a, b) => {
                            if (b.startAnchor.row !== a.startAnchor.row)
                                return b.startAnchor.row - a.startAnchor.row;
                            return b.startAnchor.column - a.startAnchor.column;
                        });

                        for (const item of sorted) {
                            const lines = temp.split('\n');

                            // ── Recalculate index from current temp ──
                            // (anchors track original positions, temp may have shifted)
                            // Re-verify the text at position still matches originalText
                            let si = 0;
                            for (let r = 0; r < item.startAnchor.row; r++) {
                                si += (lines[r]?.length ?? 0) + 1;
                            }
                            si += item.startAnchor.column;

                            let ei = 0;
                            for (let r = 0; r < item.endAnchor.row; r++) {
                                ei += (lines[r]?.length ?? 0) + 1;
                            }
                            ei += item.endAnchor.column;

                            // ── Safety check — verify text at position matches ──
                            const textAtPos = temp.substring(si, ei);
                            if (textAtPos !== item.originalText) {
                                console.warn(
                                    `Autoapply skip: expected "${item.originalText}" but found "${textAtPos}" at row:${item.startAnchor.row} col:${item.startAnchor.column}`
                                );
                                continue;
                            }

                            temp = temp.substring(0, si) + item.suggestionText + temp.substring(ei);
                        }

                    } catch (err) {
                        console.error(`Autoapply style "${style.name}" error:`, err);
                    }
                }

                // ── Update the real editor session with final result ──
                const currentContent = session.getValue();

                if (currentContent !== temp) {
                    session.markUndoGroup();  // ← start: everything below is one undo group

                    const AceRange = window.ace.require('ace/range').Range;
                    const lastRow = session.getLength() - 1;
                    const lastCol = session.getLine(lastRow).length;
                    const fullRange = new AceRange(0, 0, lastRow, lastCol);

                    session.replace(fullRange, temp);

                    session.markUndoGroup();  // ← end
                }

                setTextFile(temp);
                props.autoapplyonoff();
                props.StopLoading();
                return [];
            }
            // ── SPREAD new anchors into Redux (not replace) ──
            try {
                if (newAnchorList.length > 0) {
                    props.uploadAutoSuggestions(newAnchorList);
                }
            } catch (err) {
                console.log("Upload error:", err);
            } finally {
                props.StopLoading();
            }

            // ── Update in-memory list ──
            const surviving = existingSuggestions.filter(i => !allStaleIds.has(i.id));
            globalAnchorList = [...surviving, ...newAnchorList];

            session._signal("changeBackMarker");
            editor.renderer.updateBackMarkers();
            editor.renderer.updateFull(true);

            // ── Setup hover listener once ──
            if (!editor.container._hoverListenerSetup) {
                setupHoverListener(editor, setTextFile, props);
                editor.container._hoverListenerSetup = true;
            } else {
                // ── Update props ref every keystroke so popup has fresh dispatch ──
                if (editor.container._updatePropsRef) {
                    editor.container._updatePropsRef(props);
                }
            }

            props.StopLoading();
            return newAnchorList;

        } catch (error) {
            console.error("AutoSuggestion error:", error);
            props.StopLoading();
            return [];
        }

    } else {
        // View switched away — clear everything
        clearAutoSuggestions(ace);
        props.NoSuggestions();
        props.autoSuggestions?.forEach(item => {
            if (item.markerId) ace.current.editor.session.removeMarker(item.markerId);
            if (item.startAnchor?.detach) item.startAnchor.detach();
            if (item.endAnchor?.detach) item.endAnchor.detach();
        });
        props.clearAutoSuggestions();
        props.clearAutoSuggestionRejects();
        return [];
    }
}

function setupHoverListener(editor, setTextFile, props) {
    const container = editor.container;
    let currentPopup = null;
    let currentHoveredItem = null;
    let isMouseOverPopup = false;
    let hidePopupTimeout = null;
    let showPopupTimeout = null;
    let propsRef = props;
    container._updatePropsRef = (newProps) => { propsRef = newProps; };
    const hoverListener = (e) => {
        if (hidePopupTimeout) { clearTimeout(hidePopupTimeout); hidePopupTimeout = null; }
        if (isMouseOverPopup) return;

        const position = editor.renderer.screenToTextCoordinates(e.clientX, e.clientY);
        const hoveredItem = findHoveredItem(position);

        if (hoveredItem) {
            const startRow = hoveredItem.startAnchor.row;
            const endRow = hoveredItem.endAnchor.row;
            const startCol = hoveredItem.startAnchor.column;
            const endCol = hoveredItem.endAnchor.column;

            // ── Fix: handle both single-line and multi-line anchors ──
            let isOverActualText;
            if (startRow === endRow) {
                // Single line — check column range
                isOverActualText = position.column >= startCol && position.column < endCol;
            } else {
                // Multi line — if on start row, just need to be past startCol
                // if on end row, need to be before endCol
                // if on middle row, always true
                if (position.row === startRow) {
                    isOverActualText = position.column >= startCol;
                } else if (position.row === endRow) {
                    isOverActualText = endCol === 0
                        ? true   // ← endCol 0 means entire previous line is covered
                        : position.column < endCol;
                } else {
                    isOverActualText = true;
                }
            }

            if (isOverActualText) {
                if (hoveredItem !== currentHoveredItem) {
                    if (showPopupTimeout) { clearTimeout(showPopupTimeout); showPopupTimeout = null; }
                    if (currentPopup) { removePopup(); currentPopup = null; }

                    currentHoveredItem = hoveredItem;

                    showPopupTimeout = setTimeout(() => {
                        if (currentHoveredItem === hoveredItem) {
                            currentPopup = showPopup(
                                e, editor, hoveredItem, setTextFile,
                                () => { isMouseOverPopup = false; currentHoveredItem = null; },
                                (value) => { isMouseOverPopup = value; },
                                propsRef
                            );
                        }
                    }, 1000);
                }
            }
        } else if (currentHoveredItem && !isMouseOverPopup) {
            if (showPopupTimeout) { clearTimeout(showPopupTimeout); showPopupTimeout = null; }
            hidePopupTimeout = setTimeout(() => {
                if (!isMouseOverPopup) {
                    currentHoveredItem = null;
                    removePopup();
                    currentPopup = null;
                }
            }, 150);
        }
    };


    const mouseLeaveListener = (e) => {

        // Clear any pending show timeout
        if (showPopupTimeout) {
            clearTimeout(showPopupTimeout);
            showPopupTimeout = null;
        }

        // Clear hide timeout
        if (hidePopupTimeout) {
            clearTimeout(hidePopupTimeout);
            hidePopupTimeout = null;
        }

        // Close popup immediately if mouse is not over it
        if (!isMouseOverPopup) {
            currentHoveredItem = null;
            removePopup();
            currentPopup = null;
        }
    };

    const globalMouseMoveListener = (e) => {
        // Check if mouse is outside the editor bounds
        const editorRect = container.getBoundingClientRect();
        const isOutside =
            e.clientX < editorRect.left ||
            e.clientX > editorRect.right ||
            e.clientY < editorRect.top ||
            e.clientY > editorRect.bottom;

        if (isOutside && !isMouseOverPopup) {
            // Mouse is outside editor and not over popup
            if (showPopupTimeout) {
                clearTimeout(showPopupTimeout);
                showPopupTimeout = null;
            }

            if (currentHoveredItem) {
                currentHoveredItem = null;
                removePopup();
                currentPopup = null;
            }
        }
    };

    // Add event listeners
    container.addEventListener('mousemove', hoverListener);
    container.addEventListener('mouseleave', mouseLeaveListener);
    document.addEventListener('mousemove', globalMouseMoveListener);

    // Store references for cleanup
    container._hoverListener = hoverListener;
    container._mouseLeaveListener = mouseLeaveListener;
    container._globalMouseMoveListener = globalMouseMoveListener;
}


function findHoveredItem(position) {
    const rejectedIds = new Set(globalRejectedAnchorList.map(r => r.id));
    const activeSuggestions = globalAnchorList.filter(item => !rejectedIds.has(item.id));

    return activeSuggestions.find(item => {
        if (item.queryOnly) return false;
        const startRow = item.startAnchor.row;
        const startCol = item.startAnchor.column;
        const endRow = item.endAnchor.row;
        const endCol = item.endAnchor.column;

        if (position.row < startRow || position.row > endRow) return false;

        if (startRow === endRow) {
            return position.column >= startCol && position.column <= endCol;
        }

        if (position.row === startRow) {
            return position.column >= startCol;
        }

        if (position.row === endRow) {
            // ── endCol 0 means the range ends at start of this row ──
            // so hovering on endRow itself is NOT inside the range
            return endCol > 0 && position.column <= endCol;
        }

        return true; // middle rows always inside
    });
}

function showPopup(mouseEvent, editor, item, setTextFile, onPopupClose, setMouseOverPopup, props) {
    removePopup();

    const popupContainer = document.createElement('div');
    popupContainer.className = 'ace-suggestion-popup-container';
    popupContainer.id = 'ace-suggestion-popup';

    const popup = createAutoSuggestionPopup(
        item,
        () => {
            acceptSuggestion(editor, item, setTextFile, props);
            handleClose(popupContainer, null, setMouseOverPopup, onPopupClose);
        },
        () => {
            rejectSuggestion(item, props, editor);
            handleClose(popupContainer, null, setMouseOverPopup, onPopupClose);
        },
        () => {
            handleClose(popupContainer, null, setMouseOverPopup, onPopupClose);
        }
    );

    popupContainer.appendChild(popup);

    // ── Render invisibly first to measure dimensions ──
    popupContainer.style.cssText = `
        visibility: hidden;
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1000;
    `;
    editor.container.appendChild(popupContainer);

    const popupHeight = popupContainer.offsetHeight;
    const popupWidth = popupContainer.offsetWidth;

    const renderer = editor.renderer;
    const editorRect = editor.container.getBoundingClientRect();
    const lineHeight = renderer.lineHeight;
    const editorWidth = editorRect.width;
    const editorHeight = editorRect.height;
    const padding = 0;

    // ── Use MOUSE position for horizontal, anchor row for vertical ──
    const mouseXInEditor = mouseEvent.clientX - editorRect.left;

    // ── Get vertical position from anchor's row ──
    const { row } = item.startAnchor;
    const lineScreenPos = renderer.textToScreenCoordinates(row, item.startAnchor.column);
    const lineTop = lineScreenPos.pageY - editorRect.top;
    const lineBottom = lineTop + lineHeight;

    // ── Vertical: prefer above, fall back to below ──
    let top, placement;
    if (lineTop > popupHeight + padding) {
        top = lineTop - popupHeight - padding;
        placement = "ABOVE";
    } else if (editorHeight - lineBottom > popupHeight + padding) {
        top = lineBottom + padding;
        placement = "BELOW";
    } else if (lineTop > editorHeight - lineBottom) {
        top = Math.max(padding, lineTop - popupHeight - padding);
        placement = "ABOVE-CLAMPED";
    } else {
        top = Math.min(editorHeight - popupHeight - padding, lineBottom + padding);
        placement = "BELOW-CLAMPED";
    }

    // ── Horizontal: center on mouse position ──
    // Try to center popup on cursor, then check if it fits
    let left;
    const halfPopup = popupWidth / 2;
    const centeredLeft = mouseXInEditor - halfPopup;

    const spaceRight = editorWidth - mouseXInEditor;
    const spaceLeft = mouseXInEditor;

    if (centeredLeft >= padding && centeredLeft + popupWidth <= editorWidth - padding) {
        // ── Centered on cursor fits perfectly ──
        left = centeredLeft;
        placement += "-CENTER";
    } else if (spaceRight >= popupWidth + padding) {
        // ── More space on right — align left edge to cursor ──
        left = mouseXInEditor;
        placement += "-RIGHT";
    } else if (spaceLeft >= popupWidth + padding) {
        // ── More space on left — align right edge to cursor ──
        left = mouseXInEditor - popupWidth;
        placement += "-LEFT";
    } else if (spaceRight > spaceLeft) {
        // ── Clamp to right edge ──
        left = Math.min(mouseXInEditor, editorWidth - popupWidth - padding);
        placement += "-RIGHT-CLAMPED";
    } else {
        // ── Clamp to left edge ──
        left = Math.max(padding, mouseXInEditor - popupWidth);
        placement += "-LEFT-CLAMPED";
    }

    // ── Final safety clamp ──
    top = Math.max(padding, Math.min(top, editorHeight - popupHeight - padding));
    left = Math.max(padding, Math.min(left, editorWidth - popupWidth - padding));

    popupContainer.style.top = `${top}px`;
    popupContainer.style.left = `${left}px`;
    popupContainer.style.visibility = 'visible';

    if (placement.includes("ABOVE")) {
        popupContainer.classList.add('popup-above');
        popupContainer.classList.remove('popup-below');
    } else {
        popupContainer.classList.add('popup-below');
        popupContainer.classList.remove('popup-above');
    }

    popupContainer.addEventListener('mouseenter', () => setMouseOverPopup(true));
    popupContainer.addEventListener('mouseleave', () => {
        setMouseOverPopup(false);
        setTimeout(() => {
            handleClose(popupContainer, null, setMouseOverPopup, onPopupClose);
        }, 300);
    });

    return popupContainer;
}


function createAutoSuggestionPopup(item, onAccept, onReject, onClose) {

    const popup = document.createElement('div');
    popup.className = 'ace-suggestion-popup';
    popup.addEventListener('wheel', (e) => e.stopPropagation(), { passive: true });

    // ── Close Button ──
    const closeBtn = document.createElement('button');
    closeBtn.className = 'popup-close-btn';
    closeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" 
        stroke="currentColor" stroke-width="2" stroke-linecap="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>`;
    closeBtn.addEventListener('click', onClose);
    popup.appendChild(closeBtn);

    // ── Header ──
    const header = document.createElement('div');
    header.className = 'popup-header';
    const headerText = document.createElement('span');
    headerText.className = 'popup-header-text';
    headerText.textContent = item.styleInfo.description;
    header.appendChild(headerText);
    header.setAttribute('data-title', item.styleInfo.description);
    popup.appendChild(header);

    // ── Content ──
    const content = document.createElement('div');
    content.className = 'popup-content';

    // ── Original block ──
    const originalBlock = document.createElement('div');
    originalBlock.className = 'popup-block original-block';

    const originalLabel = document.createElement('span');
    originalLabel.className = 'popup-block-label';
    originalLabel.textContent = 'Original';

    const originalText = document.createElement('div');
    originalText.className = 'popup-block-text';
    originalText.textContent = item.originalText || '';

    // ── Scroll on hover ──
    originalText.addEventListener('mouseenter', () => {
        originalText._wheelHandler = (e) => {
            e.stopPropagation();
            e.preventDefault();
            originalText.scrollTop += e.deltaY;
        };
        originalText.addEventListener('wheel', originalText._wheelHandler, { passive: false });
    });
    originalText.addEventListener('mouseleave', () => {
        if (originalText._wheelHandler) {
            originalText.removeEventListener('wheel', originalText._wheelHandler);
            originalText._wheelHandler = null;
        }
    });

    originalBlock.appendChild(originalLabel);
    originalBlock.appendChild(originalText);

    // ── Arrow ──
    const arrow = document.createElement('div');
    arrow.className = 'popup-arrow-down';
    arrow.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" 
        stroke="currentColor" stroke-width="2" stroke-linecap="round">
        <line x1="12" y1="5" x2="12" y2="19"/>
        <polyline points="19 12 12 19 5 12"/>
    </svg>`;

    // ── Suggestion block ──
    const suggestionBlock = document.createElement('div');
    suggestionBlock.className = 'popup-block suggestion-block';

    const suggestionLabel = document.createElement('span');
    suggestionLabel.className = 'popup-block-label';
    suggestionLabel.textContent = 'Suggested';

    const suggestionText = document.createElement('div');
    suggestionText.className = 'popup-block-text';
    suggestionText.textContent = item.suggestionText
        ? item.suggestionText
        : 'this content will be deleted';

    // ── Scroll on hover ──
    suggestionText.addEventListener('mouseenter', () => {
        suggestionText._wheelHandler = (e) => {
            e.stopPropagation();
            e.preventDefault();
            suggestionText.scrollTop += e.deltaY;
        };
        suggestionText.addEventListener('wheel', suggestionText._wheelHandler, { passive: false });
    });
    suggestionText.addEventListener('mouseleave', () => {
        if (suggestionText._wheelHandler) {
            suggestionText.removeEventListener('wheel', suggestionText._wheelHandler);
            suggestionText._wheelHandler = null;
        }
    });

    suggestionBlock.appendChild(suggestionLabel);
    suggestionBlock.appendChild(suggestionText);

    content.appendChild(originalBlock);
    content.appendChild(arrow);
    content.appendChild(suggestionBlock);
    popup.appendChild(content);

    // ── Actions ──
    const actions = document.createElement('div');
    actions.className = 'popup-actions';

    const acceptBtn = document.createElement('button');
    acceptBtn.className = 'popup-btn accept';
    acceptBtn.innerHTML = `<svg width="13" height="13" viewBox="0 0 16 16" fill="none">
        <path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="currentColor" 
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg> Accept`;
    acceptBtn.addEventListener('click', onAccept);

    const rejectBtn = document.createElement('button');
    rejectBtn.className = 'popup-btn reject';
    rejectBtn.innerHTML = `<svg width="13" height="13" viewBox="0 0 16 16" fill="none">
        <path d="M12 4L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg> Ignore`;
    rejectBtn.addEventListener('click', onReject);

    actions.appendChild(acceptBtn);
    actions.appendChild(rejectBtn);
    popup.appendChild(actions);

    return popup;
}

function handleClose(container, root, setMouseOverPopup, onPopupClose) {
    if (document.getElementById('ace-suggestion-popup') === container) {
        setMouseOverPopup(false);
        container.remove();
        if (onPopupClose) onPopupClose();
    }
}

function acceptSuggestion(editor, item, setTextFile, props) {
    acceptItem(editor, item, setTextFile, props);
}

function rejectSuggestion(item, props, editor) {
    rejectItem(editor, item, props);
}
function removePopup() {
    const existing = document.getElementById('ace-suggestion-popup');
    if (existing) existing.remove();
}

function clearPreviousMarkers(ace) {
    if (!ace?.current || globalAnchorList.length === 0) return;
    const session = ace.current.editor.session;
    globalAnchorList?.forEach(item => {
        if (item.markerId) session.removeMarker(item.markerId);   // ← already safe, markerId is null
        if (item.startAnchor?.detach) item.startAnchor.detach();  // ← guard with .detach check
        if (item.endAnchor?.detach) item.endAnchor.detach();
    });
    globalAnchorList = [];
}
function cleanupStaleRejectedAnchors(texFile) {
    const lines = texFile.split('\n');
    const toDetach = [];

    globalRejectedAnchorList = globalRejectedAnchorList.filter(item => {
        const row = item.startAnchor.row;
        const col = item.startAnchor.column;
        const line = lines[row];

        if (line === undefined) {
            toDetach.push(item);
            return false;
        }

        const textAtPos = line.substring(col, col + item.originalText.length);
        if (textAtPos !== item.originalText) {
            toDetach.push(item);
            return false;
        }

        return true; // still valid — keep tracking
    });

    // Detach anchors that are no longer needed
    toDetach.forEach(item => {
        if (item.startAnchor?.detach) item.startAnchor.detach();
    });
}

export function clearAutoSuggestions(ace) {
    if (!ace?.current) return;
    const session = ace.current.editor.session;
    const container = ace.current.editor.container;

    if (container._hoverListener) {
        container.removeEventListener('mousemove', container._hoverListener);
        delete container._hoverListener;
    }
    if (container._mouseLeaveListener) {
        container.removeEventListener('mouseleave', container._mouseLeaveListener);
        delete container._mouseLeaveListener;
    }
    if (container._globalMouseMoveListener) {
        document.removeEventListener('mousemove', container._globalMouseMoveListener);
        delete container._globalMouseMoveListener;
    }
    delete container._hoverListenerSetup;

    removePopup();

    globalAnchorList.forEach(item => {
        if (item.markerId) session.removeMarker(item.markerId);
        if (item.startAnchor?.detach) item.startAnchor.detach();
        if (item.endAnchor?.detach) item.endAnchor.detach();
    });
    globalRejectedAnchorList.forEach(item => {
        if (item.startAnchor?.detach) item.startAnchor.detach(); // now safe to detach
    });
    globalAnchorList = [];
    activeStyles = [];
    globalRejectedAnchorList = [];
    globalRejectedRef = null;
    globalRejectedIds = new Set();
    globalRejectedPositions = [];
    globalRejectedKeys = new Set();  // ← reset
}

export function getAvailableStyles() {
    return Object.keys(eplStyles).map(key => ({
        id: key,
        name: eplStyles[key].name,
        description: eplStyles[key].description
    }));
}

